module.exports = __webpack_public_path__ + "media/images/sapir-685dd88b83380b17abc38c1c134699aa.png";